import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import ReactTooltip from 'react-tooltip'
import { Marker, SVGIcon, BoxedLink, Container } from 'components/qstrap'
import BaseTemplate from 'components/templates/BaseTemplate'

class Locations extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.changeState = this.changeState.bind(this)
  }

  provinceKey(value) {
    return value.replace(/\s+/g, '').toLowerCase()
  }

  changeState(stateName, value) {
    const newState = {}
    newState[this.provinceKey(stateName)] = value
    this.setState(newState)
  }

  render() {
    return (
      <BaseTemplate noBreadcrumb useNewHeader>
        <div id="Location">
          <div className="box-body blue-darker p-b-lg">
            <Container>
              <div className="map-canvas hidden-sm-down">
                {this.props.locations.map(location => (
                  <Marker
                    key={location.id}
                    data-tip={location.name}
                    location={this.provinceKey(location.name)}
                    active={this.state[this.provinceKey(location.name)]}
                  />
                ))}

                <ReactTooltip />

                <div className="content-title-abs">
                  <SVGIcon name="province" className="pull-left m-r-sm icon-title" size="lg" />
                  <div>
                    <div className="subtitle">{intl.get('locations.search_schools_by')}</div>
                    <h4 className="title">{intl.get('locations.location')}</h4>
                  </div>
                </div>
              </div>

              <div className="row boxed-link-container">
                {this.props.locations.map(location => (
                  <div key={location.id} className="col-md-4 col-lg-3">
                    <a
                      href={`/directory?location=${location.name}`}
                      onMouseEnter={() => this.changeState(location.name, true)}
                      onMouseLeave={() => this.changeState(location.name, false)}
                    >
                      <BoxedLink color="white" svgIcon="next" name={location.name} />
                    </a>
                  </div>
                ))}
              </div>
            </Container>
          </div>
        </div>

      </BaseTemplate>
    )
  }
}

Locations.propTypes = { locations: PropTypes.array }
Locations.defaultProps = { locations: [] }

export { Locations }
export default branch({
  locations: ['serverProps', 'locations'],
}, Locations)
